import companyInput from './saveInputs/companyInput';

export default (company) => `
    saveOrg (org: {
        ${companyInput(company)}
    }) {
        id
    }
`;
